var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCsvFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.33333 0.666672H10.2761L14 4.39053V14C14 14.7364 13.403 15.3333 12.6667 15.3333H3.33333C2.59695 15.3333 2 14.7364 2 14V2.00001C2 1.26363 2.59695 0.666672 3.33333 0.666672ZM8.66667 2.00001H3.33333V14H12.6667V6H10C9.26362 6 8.66667 5.40305 8.66667 4.66667V2.00001ZM10 2.27615V4.66667H12.3905L10 2.27615Z",
  fill: "#636766"
}))));
export { SvgCsvFile as ReactComponent };
export default __webpack_public_path__ + "7c3736e6c17c11c69d9fd7a657620bfa.svg";